import {attributionContextLogType} from '@deezer/logcenter';

export const LogType = {
	ADBLOCK: 'ads.adblock',
	ATTRIBUTION_CONTEXT: attributionContextLogType,
	Gauge: 'metrics.gauge',
	CDP: 'cdp',
} as const;
